// extracted by mini-css-extract-plugin
export var bannerDescription = "r_bk";
export var bannerHeadline = "r_4";
export var bannerItem = "r_6";
export var bannerList = "r_5";
export var bannerWrapper = "r_3";